import type { MutableRefObject } from 'react'
import { atom } from 'jotai'
import type { Map } from 'mapbox-gl'
import type { DrawArea } from '@app/types/layerTypes'

import type { PrioritisationMapLayer } from '@app/types/prioritisationTypes'
export type PrioritisationMapPadding = {
  top: number
  right: number
  bottom: number
  left: number
}

export const selectedPrioLayerAtom = atom<PrioritisationMapLayer | null>(null)

export const prioritisationMapInstanceAtom = atom<Map | null>(null)

export const prioritisationMapPaddingRefAtom = atom<MutableRefObject<PrioritisationMapPadding>>({
  current: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
})

export const prioritisationDrawAreasAtom = atom<DrawArea[]>([])
